import Vue from 'vue'
import Vuex from 'vuex'

//import { clone } from '@/utils'
//import scoopQuestion from './scoopQuestion'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    name: "",
    headerUser: "",
    rating: -1,
    ratingUser: -1,
    social: {},
    description: "",
    questions: [],
    info: {},
    timeLimit: 5*60,
    time: 0,
    finished: false,
  },
  mutations: {
    setHeaderUser (state, payload) {
      payload.scoop.headerUser = payload.header;
    },
    setRatingUser (state, payload) {
      payload.scoop.ratingUser = payload.rating;
    },
    setFinished (state, payload) {
      payload.scoop.finished = payload.finished;
    },
    setPoints (state, payload) {
      payload.scoop.points = payload.points;
    },
  },
  actions: {
  },
  getters: {
    getTimeRemaining: () => (scoop) => {
      return scoop.timeLimit - scoop.time
    },
    getPTime: (state,getters) => (scoop) => {
      return 5*(getters.getTimeRemaining(scoop)+60)
    },
    getNAnswers: () => (scoop) => {
      return scoop.questions.filter(q => q.answerUser != -1).length;
    },
    getNCorrect: () => (scoop) => {
      return scoop.questions.filter(q => q.answerUser == q.answerCorrect).length;
    },
    getPCorrect: (state,getters) => (scoop) => {
      return getters.getNCorrect(scoop);
    },
    getCommentCorrect: (state,getters) => (scoop) => {
      let str = "Wow, very well reviewed!"
      let n = getters.getNCorrect(scoop)
      if(n == 3){
        str = "Well reviewed."
      }
      else if(n == 2){
        str = "Well reviewed, but I think you can do better."
      }
      else if(n == 1){
        str = "Try to review the news more closely."
      }
      else if(n == 0){
        str = "You need to review the news better."
      }
      return str;
    },
    getCorrectRating: () => (scoop) => {
      return scoop.rating == scoop.ratingUser
    },
    getDRating: () => (scoop) => {
      return Math.abs(scoop.ratingUser - scoop.rating)
    },
    getPRating: (state,getters) => (scoop) => {
      return 500-250*getters.getDRating(scoop);
    },
    getCommentRating: (state,getters) => (scoop) => {
      let str = "A good assessment!"
      let d = getters.getDRating(scoop)
      if(d >= 3){
        str = "Mhm, not quite there, but close."
      }
      if(d == 2){
        str = "Not quite rightly judged."
      }
      else if(d == 1){
        str = "I think that was a pretty good assessment."
      }
      return str;
    },
    getCommentHeader: () => () => {
      let strs = ["Interesting!", "Awsome!", "Exciting!", "Nice!", "Good angle!"]
      return strs[Math.floor(Math.random()*strs.length)];
    },
    calcPoints: (state,getters) => (scoop) => {
      return getters.getPCorrect(scoop) * getters.getPTime(scoop) + getters.getPRating(scoop)
    },
  },
  modules: {
    //scoopQuestion
  }
}
